@if (mainFilename$ | async; as mainFilename) {
  <vwg-angebot-v2
    *axLazyElement="'vwg-angebot-v2/' + mainFilename"
    [dispatcher]="globalEventDispatcher"></vwg-angebot-v2>
}
